import { Flex, Text } from '@chakra-ui/react';
import { faBell } from '@fortawesome/pro-regular-svg-icons';

import AdditionalInformationWrapper from '../AdditionalInformationWrapper';
import { ReviewScoreHighlight } from './ReviewScoreHighlight';
import { ReviewDetailsTab } from '../../../../pages/Review';
import { Accordion } from '@morressier/alembic';
import { IconBadge } from '../../../IconBadge';

export const ReviewerRejectedAdditionalInfo = ({
  setActiveTab
}: {
  setActiveTab: (tab: ReviewDetailsTab) => void;
}) => {
  return (
    <AdditionalInformationWrapper>
      <Accordion
        chakraAccordionProps={{
          width: '100%',
          defaultIndex: 0
        }}
        items={[
          {
            title: (
              <Flex alignItems={'flex-start'} gap={2}>
                <IconBadge icon={faBell} variant="neutral" />
                <Flex flexDirection={'column'} marginLeft={2}>
                  <Text textStyle="headingItem">Highlights</Text>
                  <Text textStyle="textContext">
                    Review key updates and assessment information for this
                    revision phase.
                  </Text>
                </Flex>
              </Flex>
            ),
            content: (
              <Flex flexDirection="column" width="100%" gap={4}>
                <ReviewScoreHighlight setActiveTab={setActiveTab} />
              </Flex>
            )
          }
        ]}
      />
    </AdditionalInformationWrapper>
  );
};
